"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delay = delay;
exports.isBooleans = isBooleans;
exports.isStrings = isStrings;
async function delay(milliseconds) {
  await new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, milliseconds);
  });
}
function isStrings(array) {
  if (!Array.isArray(array)) {
    return false;
  }
  if ((array === null || array === void 0 ? void 0 : array.length) === 0) {
    return true;
  }
  return typeof array[0] === "string";
}
function isBooleans(array) {
  if (!Array.isArray(array)) {
    return false;
  }
  if ((array === null || array === void 0 ? void 0 : array.length) === 0) {
    return true;
  }
  return typeof array[0] === "boolean";
}
//# sourceMappingURL=other.js.map